import { render, staticRenderFns } from "./TextLabelForm.vue?vue&type=template&id=3d04bf96&"
import script from "./TextLabelForm.vue?vue&type=script&lang=js&"
export * from "./TextLabelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports